import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=1b613015&scoped=true"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"
import style0 from "./LinkButton.vue?vue&type=style&index=0&id=1b613015&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b613015",
  null
  
)

export default component.exports